/** admin/import — API. All requests use the shared ApiError response contract. */
import { http } from '../../_shared/http';
import type { ImportSummary, ImportPlanResponse, ImportExecuteResponse, ImportJobDetail, PaginatedJobs } from './types';

export const importApi = {
  preview: (file: object) => http.post<ImportPlanResponse>('/admin/import/preview', file),
  execute: (file: object, expectedSummary?: ImportSummary) =>
    http.post<ImportExecuteResponse>('/admin/import/execute', { file, expectedSummary }),

  listJobs: (page = 1, limit = 20) =>
    http.get<PaginatedJobs>(`/admin/import/jobs?page=${page}&limit=${limit}`),

  getJob: (jobId: string) => http.get<ImportJobDetail>(`/admin/import/jobs/${jobId}`),
};
